<ng-container *ngIf="assetPath">
    <router-outlet></router-outlet>
</ng-container>